import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const DialogIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 17"
      height={getDefaultHeight(svgProps, 17)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeWidth="1.5"
    >
      <path
        d="M15.8 1H2.2c-.3 0-.6.1-.8.3-.3.3-.4.6-.4.9V12c0 .3.1.6.4.8.2.2.5.3.8.3h2.5v3l3.8-3h7.3c.3 0 .6 0 .8-.3.3-.2.4-.5.4-.8V2c0-.2-.1-.5-.4-.8-.2-.2-.5-.3-.8-.3Z"
        strokeLinejoin="round"
      />
      <path d="M4.7 5.1h8.6M4.7 7.8h5.7" />
    </SVG>
  );
};
